import Axios from 'axios';

import useSessionStore from '@/stores/session';
import $offline from '@/utils/offline';
import $path from '@/utils/path';

export default {
  /**
   * fetch function to call axios
   * @async
   * @param {FetchOptions} options {method, url, data, headers}
   * @returns {Promise} Promise with the result of the axios request
   */
  async fetch(options) {
    const SessionStore = useSessionStore();

    const axiosOptions = {
      method: options.method,
      url: $path.resolveAPI(options.url),
      data: options.data,
      headers: {
        Authorization: SessionStore.token ? `Bearer ${SessionStore.token}` : '',
        ...options.headers,
      },
    };

    // Try to recover localstorage token from pinia token when a request sent
    const storedToken = localStorage.getItem('hub-facilitator-portal-token');

    if (!storedToken || storedToken === 'null') {
      await SessionStore.updateAuthToken({
        newToken: SessionStore.token,
      });
    }

    const OnlineOnly = Number(process.env.VUE_APP_ONLINE_ONLY || 0) === 1;

    let response = null;

    try {
      response = await (navigator.onLine || OnlineOnly ? Axios(axiosOptions) : $offline.query(axiosOptions));
    } catch (err) {
      return { success: false, message: err.response.data.message };
    }

    if (!response || !response.data) {
      return { success: false, message: 'Server error' };
    }

    if (!response.data.success) {
      if (['JsonWebTokenError', 'TokenExpiredError'].includes(response.data.message)) {
        await SessionStore.clearSession();
        // window.location.replace($path.resolveApp);
      }

      return { success: false, message: response.data.message };
    }

    // Replace old token if server send a new token back
    if (response.headers && response.headers['renewed-token']) {
      await SessionStore.updateAuthToken({
        newToken: response.headers['renewed-token'],
      });

      return response.data;
    }

    // Receive a new token from login response and pass it
    if (response.headers && response.headers['new-token']) {
      response.data.newToken = response.headers['new-token'];
    }

    return response.data;
  },

  get(url, data) {
    return this.fetch({
      method: 'get',
      url,
      data,
    });
  },

  post(url, data) {
    return this.fetch({
      method: 'post',
      url,
      data,
    });
  },

  patch(url, data) {
    return this.fetch({
      method: 'patch',
      url,
      data,
    });
  },

  put(url, data) {
    return this.fetch({
      method: 'put',
      url,
      data,
    });
  },

  delete(url) {
    return this.fetch({
      method: 'delete',
      url,
    });
  },
};
